export type ShopifyCartItemType = {
    originalPrice?: number | string; // 原价
    discountPrice: number | string; // 折扣价
    img: string; // 图片
    productImg?: string;
    title: string; // 产品名称/标题
    productId?: string; // 产品id
    variantId: string; // 变体id
    quantity?: number; // 购物车数量
    inventory?: number; // 库存数量
    parentVariantId?: string; // 附属加购产品之父级主产品变体id（见/cost-saving页）
};

export type ShopifyCartProps = {
    items: ShopifyCartItemType[];
    callback: (param: ShopifyCartItemType[], isClose?: boolean) => void;
};

export interface CouponGiftProductItemType {
    price?: number;
    quantity?: number;
    productId?: string | number;
    variantId?: string | number;
}

export interface CouponCountdownDateType {
    d: string;
    h: string;
    m: string;
    s: string;
}

export interface CouponGiftType {
    source: 'CART' | 'CHECK_OUT';
    productList?: CouponGiftProductItemType[];
}

export interface CouponHitProductType extends CouponGiftProductItemType {
    discount: number;
    totalPrice: number;
}

export interface CouponType {
    amount: string | number;
    code: string;
    currencySymbol: string;
    discountAmount: string | number;
    discountType: string;
    discountablePrice: number;
    endTime: string;
    startTime: string;
    ruleType: 'COUPONS' | 'GIFT_CARD';
    site: string;
    title: string;
    hitProducts: CouponHitProductType[];
}

export const currencySymbolLocalMap: any = {
    us: '$', // 前面
    ca: '$', // 前
    uk: '£', // 前
    eu: '€', // 前
    de: '€', // 后
    fr: '€', // 后
    it: '€', // 后
    es: '€', // 后
    cis: '₽', // 后
    jp: '¥', // 前
    cn: '¥', // 前
    kr: '₩', // 前
    sa: 'د.إ', // 前
    za: 'R', // 前
    au: '$', // 前
    tw: 'NT$', // 前
    hk: 'HK$', //前
    br: 'R$',
    mx: 'MXN ',
    ph: '₱',
};

export const FormatMoneyLocal = (key: number | string, locale: string, splitStr = ',') => {
    let value: any = 0;
    const PERIOD_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es'];
    if (key || key === 0) {
        let tmpKey = key.toString();
        // 欧德法意西 小数点用逗号[,]表示 其余用小数点[.]
        if (PERIOD_SITES.includes(locale)) {
            tmpKey = tmpKey.replace('.', ',');
        }
        // 千分位分隔符 欧德法意西用小数点[.] 其余默认用逗号[,]或自定义符号
        const reg = /(\d)(?=(\d{3})+$)/g;
        value =
            tmpKey.replace(reg, `$1${splitStr !== ',' ? splitStr : PERIOD_SITES.includes(locale) ? '.' : splitStr}`) +
            (['de', 'fr', 'it', 'es']?.includes(locale) ? ' ' : '');
    }
    const backSort: string[] = ['de', 'fr', 'it', 'es', 'cis'];
    return backSort?.includes(locale)
        ? value + (currencySymbolLocalMap[locale] || currencySymbolLocalMap.us)
        : (currencySymbolLocalMap[locale] || currencySymbolLocalMap.us) + value + (locale === 'jp' ? '（税込）' : '');
};
